import React from "react";
import PropTypes from "prop-types";

const CircleProgressComponent = ({ height, width, percentage, primaryColor, strokeWidth, widthNumber }) => {
  const size = widthNumber || 35;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  
  const gradientColor = Array.isArray(primaryColor) ? primaryColor[0] : primaryColor;
  const gradientColorEnd = Array.isArray(primaryColor) && primaryColor[1] ? primaryColor[1] : gradientColor;

  return (
    <div style={{ height: height, width: width }}>
      {percentage !== undefined && primaryColor && (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <defs>
            <linearGradient id={`gradient-${percentage}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor={gradientColor} />
              <stop offset="100%" stopColor={gradientColorEnd} />
            </linearGradient>
          </defs>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="var(--background-brand-primary-hover, #2a2a3e)"
            strokeWidth={strokeWidth}
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={`url(#gradient-${percentage})`}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{ transition: "stroke-dashoffset 0.3s ease" }}
          />
        </svg>
      )}
    </div>
  );
};

CircleProgressComponent.propTypes = {
  primaryColor: PropTypes.array.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  widthNumber: PropTypes.number.isRequired,
};

export default CircleProgressComponent;
